import { Box, Divider, Flex, Menu, MenuButton, MenuList } from "@chakra-ui/react";
import { RiSettings3Line } from "react-icons/ri";
import { MdOutlineAlignHorizontalLeft } from "react-icons/md";
import { MdOutlineAlignHorizontalCenter } from "react-icons/md";
import { MdOutlineAlignHorizontalRight } from "react-icons/md";
import { optionTypes } from "./types/subWidgetOptionsTypes";
import { IoDuplicate, IoCaretUp, IoCaretDown } from 'react-icons/io5';


export const SubWidgetOptionMenu = ({ 
  type, 
  subWidgetId, 
  handleSaveSubWidgetOptions, 
  subWidgetOptions, 
  handleEditItemByClick, 
  handleDuplicateSubWidget, 
  moveSubWidgetPosition,
  isFirstSubwidget,
  isLastSubwidget
}) => {
  const typesWithOptionsMenu = ['content-divider', 'content-spacer', 'cta-button', 'youtube-video'];
  const alignableSubWidgetTypes = ['title-text', 'cta-button', 'user-signature'];
  const duplicableSubWidgetTypes = ['title-text', 'normal-text', 'cta-button', 'user-signature', 'content-spacer', 'content-divider']

  const handleChangeSubWidgetOption = (param, value) => {
    let options = {
      ...subWidgetOptions,
      [param]: value
    }

    handleSaveSubWidgetOptions(options)
  }



  const optionMenuItems = (type) => {
    switch (type) {
      case 'content-divider':
        return (
          <Box margin='10px' color='gray.500'>
            <Box display="flex" alignItems='center' my='0.5em' onClick={() => handleChangeSubWidgetOption(optionTypes.STRENGTH, 'thin')}>
              <Divider width="12px" borderBottomWidth='1px' borderColor='#CBD5E0' marginRight='10px' />
              <Box color={subWidgetOptions[optionTypes.STRENGTH] === 'thin' && 'brandDark.500'} fontWeight={subWidgetOptions[optionTypes.STRENGTH] === 'thin' ? 'bold' : 'normal'}>Thin</Box>
            </Box>
            <Box display="flex" alignItems='center' my='0.5em' onClick={() => handleChangeSubWidgetOption(optionTypes.STRENGTH, 'medium')}>
              <Divider width="12px" borderBottomWidth='2px' borderColor='#CBD5E0' marginRight='10px' />
              <Box color={subWidgetOptions[optionTypes.STRENGTH] === 'medium' && 'brandDark.500'} fontWeight={subWidgetOptions[optionTypes.STRENGTH] === 'medium' ? 'bold' : 'normal'}>Medium</Box>
            </Box>
            <Box display="flex" alignItems='center' my='0.5em' onClick={() => handleChangeSubWidgetOption(optionTypes.STRENGTH, 'bold')}>
              <Divider width="12px" borderBottomWidth='3px' borderColor='#CBD5E0' marginRight='10px' />
              <Box color={subWidgetOptions[optionTypes.STRENGTH] === 'bold' && 'brandDark.500'} fontWeight={subWidgetOptions[optionTypes.STRENGTH] === 'bold' ? 'bold' : 'normal'}>Bold</Box>
            </Box>
          </Box>
        )

      case 'content-spacer':
        return (
          <Box margin='10px' fontSize='0.875em' >
            <Box display="flex" alignItems='center' my='0.5em' onClick={() => handleChangeSubWidgetOption(optionTypes.HEIGHT, '1em')}>
              <Box fontWeight={subWidgetOptions[optionTypes.HEIGHT] === '1em' ? 'bold' : 'normal'}>Small</Box>
            </Box>
            <Box display="flex" alignItems='center' my='0.5em' onClick={() => handleChangeSubWidgetOption(optionTypes.HEIGHT, '2em')}>
              <Box fontWeight={subWidgetOptions[optionTypes.HEIGHT] === '2em' ? 'bold' : 'normal'}>Medium</Box>
            </Box>
            <Box display="flex" alignItems='center' my='0.5em' onClick={() => handleChangeSubWidgetOption(optionTypes.HEIGHT, '3em')}>
              <Box fontWeight={subWidgetOptions[optionTypes.HEIGHT] === '3em' ? 'bold' : 'normal'}>Large</Box>
            </Box>
          </Box>
        )

      case 'cta-button':
        return (
          <Flex direction='column' margin='10px' gap='0.5em' fontSize='0.875em'>
            <Flex 
              _hover={{ bg: 'gray.200', cursor: 'pointer' }} 
              padding='0.25em' 
              borderRadius='0.25em' 
              transition="background 0.3s ease-in-out"
              alignItems='center' onClick={() => handleChangeSubWidgetOption(optionTypes.VARIANT, 'primary')}
            >
              <Box fontWeight={subWidgetOptions[optionTypes.VARIANT] === 'primary' ? '600' : 'normal'}>Dark</Box>
            </Flex>
            <Flex 
              _hover={{ bg: 'gray.200', cursor: 'pointer' }}
              padding='0.25em' 
              borderRadius='0.25em'
              transition="background 0.3s ease-in-out"
              alignItems='center' onClick={() => handleChangeSubWidgetOption(optionTypes.VARIANT, 'secondary')}
            >
              <Box fontWeight={subWidgetOptions[optionTypes.VARIANT] === 'secondary' ? '600' : 'normal'}>Light</Box>
            </Flex>
          </Flex>
        )
      case 'youtube-video':
        return (
          <Box p='0.5em 10px'>
            <Box display="flex" alignItems='center' onClick={() => handleEditItemByClick()}>
              <Box fontSize='0.875em'>Edit Link</Box>
            </Box>
          </Box>
        )
      default:
        return null
    }
  }

  return (
    <>
      {alignableSubWidgetTypes.includes(type) &&
        <>
          <Box marginRight='8px' onClick={() => handleChangeSubWidgetOption(optionTypes.ALIGN, 'left')}>
            <MdOutlineAlignHorizontalLeft fill="#fff" />
          </Box>
          <Box marginRight='8px' onClick={() => handleChangeSubWidgetOption(optionTypes.ALIGN, 'center')}>
            <MdOutlineAlignHorizontalCenter fill="#fff" />
          </Box>
          <Box marginRight='8px' onClick={() => handleChangeSubWidgetOption(optionTypes.ALIGN, 'right')}>
            <MdOutlineAlignHorizontalRight fill="#fff" />
          </Box>
        </>
      }

      {typesWithOptionsMenu.includes(type) &&
        <Menu placement="bottom-end">
          <MenuButton>
            <Box marginRight='8px' >
              <RiSettings3Line fill="#fff" />
            </Box>
          </MenuButton>
          <MenuList>
            {optionMenuItems(type)}
          </MenuList>
        </Menu>
      }

{/* {duplicableSubWidgetTypes.includes(type) && */}
        <>
          {!isFirstSubwidget && <Box marginRight='8px' onClick={() => moveSubWidgetPosition('moveUp', subWidgetId)}>
            <IoCaretUp fill="#fff" />
          </Box>}
          {!isLastSubwidget &&
          <Box marginRight='8px' onClick={() => moveSubWidgetPosition('moveDown', subWidgetId)}>
            <IoCaretDown fill="#fff" />
          </Box>}
        </>
      {/* } */}

      {duplicableSubWidgetTypes.includes(type) &&
        <>
          <Box marginRight='8px' onClick={() => handleDuplicateSubWidget(subWidgetId)}>
            <IoDuplicate fill="#fff" />
          </Box>
        </>
      }
    </>
  )
}
